





































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '~/utils/nuxt3-migration'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { useDeps } from '~/compositions/dependency-container'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { ciTimes } from '~/icons/source/solid/times'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { ButtonSize, ButtonVariant } from '~/models/app/button'
import { useSnackbar } from '~/compositions/snackbar'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: { CTextArea, CConfirmationModal },
  props: {
    auditRequestId: {
      type: Number,
      required: true
    },
    actionText: {
      type: String,
      required: false,
      default: ''
    },
    confirmText: {
      type: String,
      required: false,
      default: ''
    },
    successText: {
      type: String,
      required: false,
      default: ''
    },
    size: {
      type: String as PropType<ButtonSize>,
      default: 'sm'
    },
    variant: {
      type: String as PropType<ButtonVariant>,
      default: 'danger'
    },
    outline: { type: Boolean, default: true },
    buttonClass: {
      type: [Object, String, Array],
      required: false,
      default: 'tw-w-full'
    },
    icon: {
      type: Object,
      default: undefined
    }
  },
  setup(props, { emit }) {
    const { auditRequestId } = toRefs(props)
    const cancelAuditRequestModalIsShown = ref(false)
    const cancellationReason = ref('')
    const snackbar = useSnackbar()
    const { t } = useI18n()

    const formRef = ref(null)

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isAuditsUser = computed(() => userGetters('isAuditsUser'))

    const [auditRequestService] = useDeps(AuditRequestService)

    async function cancelRequest(e: any) {
      if (
        isAuditsUser.value &&
        !cancellationReason.value &&
        formRef.value?.$el
      ) {
        e.preventDefault()
        formRef.value.$el.reportValidity()
        return
      }
      const { auditRequest } = await auditRequestService.cancelRequest(
        auditRequestId.value,
        cancellationReason.value || undefined
      )

      snackbar.success(props.successText || t('success_cancel_audit'))
      emit('change-status', auditRequest.currentStatus.status)
      emit('request-updated', auditRequest)
    }

    return {
      ciTimes,
      cancelAuditRequestModalIsShown,
      cancellationReason,
      cancelRequest,
      isAuditsUser,
      formRef
    }
  },
  i18n: defineComponentTranslations({
    success_cancel_audit: {
      en: 'The audit request was successfully canceled.',
      el: 'Το αίτημα ελέγχου ακυρώθηκε επιτυχώς'
    }
  })
})
